import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type SliderTitleClasses = 'title' | 'container' | 'titleCentered' | 'link' | 'nameContainer';

const sliderTitleStyles = makeStyles<ISpcTheme, SliderTitleClasses>(
  ({ spacing, palette, typography, breakpoints }) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: `0 0 0 ${spacing(4)}`,

      [breakpoints.down('xs')]: {
        justifyContent: 'center',
        alignItems: 'center',
        padding: `0 ${spacing(1)} 0 0`,
      },
    },
    nameContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',

      [breakpoints.up('sm')]: {
        width: '100%',
        paddingRight: '16px',
      },

      [breakpoints.down('xs')]: {
        justifyContent: 'center',
        alignItems: 'center',
        padding: `0 ${spacing(1)} 0 0`,
      },
    },

    title: {
      fontSize: 36, // Special case where we want to be 36 on every market
      marginRight: 'auto',

      [breakpoints.down('sm')]: {
        fontSize: typography.fontXL,
      },

      [breakpoints.down('xs')]: {
        fontSize: typography.fontLG,
        textAlign: 'left',
      },
    },
    titleCentered: {
      [breakpoints.down('xs')]: {
        fontSize: typography.fontLG,
        textAlign: 'center',
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    link: {
      fontFamily: typography.fontFamily,
      color: palette.secondary.main,
      paddingTop: 5,
      [breakpoints.down('xs')]: {
        fontSize: typography.fontXS,
      },
    },
  }),
  { name: 'Customise_SliderTitle' },
);

export default sliderTitleStyles;
